/**
 * Utility class containing functions useful to parse / generate url.
 */
export class UrlExtractor {
  /**
   * Returns the cloudfront url based on the current host.
   */
  public static getCloudFrontUrl(): string {
    const hostUrl = UrlExtractor.getHostUrl();
    const cloudFrontUrl = `https://pic.${hostUrl}`;

    return cloudFrontUrl;
  }

  /**
   * Returns the ash cloudfront url based on the current host.
   */
   public static getASHCloudFrontUrl(): string {
    const hostUrl = UrlExtractor.getHostUrl();
    const ashUrl = UrlExtractor.getASHUrl(hostUrl);
    const cloudFrontUrl = `https://pic.${ashUrl}`;

    return cloudFrontUrl;
  }

  /**
   * Returns the api gateway url based on the current host.
   */
  public static getApiGatewayUrl(): string {
    const hostUrl = UrlExtractor.getHostUrl();
    const apiGatewayUrl = `https://api.gw.pic.${hostUrl}`;

    return apiGatewayUrl;
  }

  /**
   * Returns the ash api gateway url based on the current host.
   */
   public static getASHApiGatewayUrl(): string {
    const hostUrl = UrlExtractor.getHostUrl();
    const ashUrl = UrlExtractor.getASHUrl(hostUrl);
    const apiGatewayUrl = `https://api.gw.pic.${ashUrl}`;

    return apiGatewayUrl;
  }

  /**
   * Returns the host url.
   */
  public static getHostUrl(): string {
    return window.location.host;
  }

  /**
   * Returns the ash url based on stage.
   */
   public static getASHUrl(host: string) {
    if(host.includes("alpha"))
      return "alpha.pdx.checklist.associate.amazondelivers.jobs";
    else if(host.includes("beta"))
      return "beta.pdx.checklist.associate.amazondelivers.jobs";
    else if (host.includes("gamma"))
      return "gamma.iad.checklist.associate.amazondelivers.jobs";
    else
      return "checklist.associate.amazondelivers.jobs";
  }
}